import { useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Camera } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useApp } from "@/context/AppContext";
import { errMsg } from "@/lib/format";

export const ReceiptScan = ({ variant = "default" }) => {
  const { api, t } = useApp();
  const nav = useNavigate();
  const ref = useRef();
  const [busy, setBusy] = useState(false);
  const send = async (file) => {
    if (!file) return;
    setBusy(true);
    const tid = toast.loading(t("receipt_reading"));
    const fd = new FormData();
    fd.append("file", file);
    try {
      const { data } = await api.post("/receipts/scan", fd);
      if (data.ocr_ok) toast.success(t("receipt_ok"), { id: tid }); else toast.warning(t("receipt_ocr_failed"), { id: tid });
      nav(`/app/documents/${data.id}/edit`);
    } catch (e) { toast.error(errMsg(e), { id: tid }); } finally { setBusy(false); }
  };
  return (
    <>
      <input ref={ref} type="file" accept="image/*,application/pdf" capture="environment" hidden data-testid="receipt-scan-input"
        onChange={(e) => { send(e.target.files[0]); e.target.value = ""; }} />
      <Button variant={variant} disabled={busy} onClick={() => ref.current.click()} data-testid="receipt-scan-btn">
        <Camera className="h-4 w-4 me-1" />{busy ? t("loading") : t("receipt_scan")}
      </Button>
    </>
  );
};
